import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../components/input/fields/text-field';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import TagsInput from "../../../components/input/tags/tags-input";
import { AddItem, GetById, UpdateItem } from '../../../utils/functions';
import { Checkbox } from "primereact/checkbox";
import Uploader from '../../../components/Uploader/Uploader';
import { Tab, Typography, Box } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import { Trash, Plus } from 'react-feather';
import { Editor } from 'primereact/editor';
import { DataContext } from '../../../App';
import { NavLink } from 'react-router-dom';
import LoadingApp from "../../../components/loadingApp/loadingApp";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


const Manage = ({ itemId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(DataContext);
  const Id = itemId ?? null;
  const [experience, setExperiences] = useState(null);
  const [optionsCategory, setOptionCategories] = useState(null);
  const [valueTabBenefits, setValueTabBenefits] = useState(0);
  const [valueTabOffers, setValueTabOffers] = useState(0);
  const [carouselDisplay, setCarouselDisplay] = useState(experience?.isCarouselDisplay ?? false);
  const [isBtnDisable, setIsBtnDisable] = useState(false);
  const [isAddDetails, setIsAddDetails] = useState(true);

  const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
  const [formValues, setFormValues] = useState({
    id: Id,
    title: null,
    category: null,
    priority: null,
    status: null,
    isCarouselDisplay: null,
    shortDescription: null,
    description: null,
    priceLists: [],
    seoInformation: {
      title: null,
      metaDescription: null,
      linkUrl: null,
      keywords: null,
    },
    linkMenu: {
      text: null,
      url: null,
      target: null,
    },
    cta: {
      text: null,
      url: null,
      target: null,
    },
    heading: {
      title: null,
      cta: {
        text: null,
        url: null,
        target: null,
      },
      description: null,
      image: null,
    },
    intro: {
      title: null,
      description: null,
      image: null,
      cta: null,
    },
    benefits: [
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
    ],
    offers: [
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
    ],
    reviews: [
      {
        title: null,
        description: null,
        image: null,
        cta: null,
      },
    ],
    faq: null,
  });

  useEffect(() => {
    if(context?.categories?.length > 0){
      const newOptions = context.categories.map((category) => ({
        value: category.value,
        label: category.label
      }));
      
      newOptions.sort((a, b) => a.label.localeCompare(b.label));

      setOptionCategories(newOptions);
    }
  }, [context.categories]);

  const optionsStatus = [
    {
      label: t("Active"),
      value: "active"
    },
    {
      label: t("Inactive"),
      value: "inactive"
    }
  ];

  const optionsCTATarget = [
    {
      label: t("SamePage"),
      value: "_self"
    },
    {
      label: t("OtherPage"),
      value: "_blank"
    },
  ];

  const optionsDetailsOrNot = [
    {
      label: t("AddDetails"),
      value: true
    },
    {
      label: t("NotAddDetails"),
      value: false
    },
  ];

  const selectedTags = (tags) => {
    const newKeywords = [...tags];
    setFormValues((prevValues) => ({
      ...prevValues,
      seoInformation: {
        ...prevValues.seoInformation,
        keywords: newKeywords
      }
    }));
  };

  const handleChangeBenefits = (event, newValue) => {
    setValueTabBenefits(newValue);
  };

  const handleChangeOffers = (event, newValue) => {
    setValueTabOffers(newValue);
  };

  const handleGalleryFiles = (filePaths, section) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [section]: {
        ...prevValues[section],
        image: [filePaths[filePaths.length - 1]]
      }
    }));
  };

  const handleGalleryExperiencesFiles = (filePaths, section, index) => {
    const updatedExperiences = formValues?.[section]?.map((item, i) =>
      i === index ? { ...item, image: [filePaths[filePaths.length - 1]] } : item
    );
    setFormValues((prevValues) => ({
      ...prevValues,
      [section]: updatedExperiences,
    }));
  };

  const handleRemoveImage = (index, section) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[section].image = null; 
      
      return updatedValues;
    });
  };

  const handleRemoveExperiencesImage = (fileIndex, section, index) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[section][index].image = null;
      
      return updatedValues;
    });
  };

  const handleSelectChange = (propertyName) => (selectedOption) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [propertyName]: selectedOption ? selectedOption.value : null,
    }));
  };

  const checkValues = () => {

    if (!formValues.title) {
      toast.error(t("ToastErrorTitleRequired"));
      return false;
    }

    if (!formValues.category) {
      toast.error(t("ToastErrorCategoryRequired"));
      return false;
    }

    if (!formValues.priority) {
      toast.error(t("ToastErrorPriorityRequired"));
      return false;
    }

    if (formValues.priority) {
      if (isNaN(formValues.priority)) {
        toast.error(t("ToastErrorPriorityIsNotValidNumber"));
        return false;
      }
    }

    if (!formValues.status) {
      toast.error(t("ToastErrorStatusRequired"));
      return false;
    }

    if (formValues.isCarouselDisplay === null) {
      formValues.isCarouselDisplay = false;
    }

    if (formValues.isCarouselDisplay) {
      if (formValues.shortDescription === null) {
        toast.error(t("ToastErrorShortDescriptionRequired"));
        return false;
      }
    }

    if (!formValues.linkMenu.text) {
      toast.error(t("ToastErrorLinkMenuTextRequired"));
      return false;
    }

    if (!formValues.linkMenu.url) {
      toast.error(t("ToastErrorLinkMenuUrlRequired"));
      return false;
    }

    if (!formValues.description) {
      toast.error(t("ToastErrorDescriptionRequired"));
      return false;
    }

    if (!formValues.cta.text) {
      toast.error(t("ToastErrorCallToActionTextRequired"));
      return false;
    }

    if (isAddDetails) {
      if (!formValues.seoInformation.title) {
        toast.error(t("ToastErrorTitleSeoRequired"));
        return false;
      }
  
      if (!formValues.seoInformation.linkUrl) {
        toast.error(t("ToastErrorLinkUrlSeoRequired"));
        return false;
      }
  
      if (!formValues.heading.title) {
        toast.error(t("ToastErrorTitleHeaderRequired"));
        return false;
      }
  
      if (!formValues.heading.description) {
        toast.error(t("ToastErrorDescriptionHeaderRequired"));
        return false;
      }
  
      if (!formValues.heading.image) {
        toast.error(t("ToastErrorImageHeaderRequired"));
        return false;
      }
  
      if (!formValues.intro.title) {
        toast.error(t("ToastErrorTitleIntroRequired"));
        return false;
      }
      if (!formValues.intro.description) {
        toast.error(t("ToastErrorDescriptionIntroRequired"));
        return false;
      }
    }
    else {
      if(!formValues.priceLists || formValues.priceLists.length === 0){
        toast.error(t("ToastErrorPriceListRequired"));
        return false;
      }
      else {
        formValues.priceLists.map((item, index) => {
          if (!item.title) {
            toast.error(t("ToastErrorTitlePriceListRequired", { index: index + 1 }));
            return false; 
          }
          if (!item.description) {
            toast.error(t("ToastErrorDescriptionPriceListRequired", { title: item.title }));
            return false;
          }
          if (!item.leftInformation) {
            toast.error(t("ToastErrorLeftInformationPriceListRequired", { title: item.title }));
            return false;
          }
          if (!item.rightInformation) {
            toast.error(t("ToastErrorRightInformationPriceListRequired", { title: item.title }));
            return false;
          }
          return true;
        });
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsBtnDisable(true);
    
    if (checkValues()) {
      try {
        if (Id) {
          await UpdateItem('Experiences', formValues);
        } else {
          await AddItem('Experiences', formValues);
        }
        await context.updateData("experiences");
        navigate("/admin/experiences")

      } catch (error) {
        console.error('ErrorExperiences', error);
      }
    }
    
    setIsBtnDisable(false);
  }

  const addPriceList = () => {
    if(!formValues.priceLists || formValues.priceLists.length === 0){
      setIsAddDetails(false);
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      priceLists: [
        ...prevValues.priceLists,
        { 
          title: null,
          description: null,
          leftInformation: null,
          rightInformation: null
        },
      ],
    }));
  };

  const removePriceList = (indexToRemove) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      priceLists: prevValues.priceLists.filter((_, index) => index !== indexToRemove),
    }));

    if(!formValues.priceLists || formValues.priceLists.length === 0){
      setIsAddDetails(true);
    }
  };

  useEffect(() => {
    const fetchExperiences = async () => {
      if (!experience && Id) {
        const data = await GetById("Experiences", Id);
        if (data) {
          setExperiences(data);
        }
      }
    };
    fetchExperiences();
  }, []);

  useEffect(() => {
    if (experience) {
      if(experience.priceLists && experience.priceLists.length > 0){
        setIsAddDetails(false);
      }
      else {
        setIsAddDetails(true);
      }
      setFormValues({
        id: Id,
        title: experience?.title ?? null,
        category: experience?.category ?? null,
        priority: experience?.priority ?? null,
        status: experience?.status ?? null,
        isCarouselDisplay: experience?.isCarouselDisplay ?? carouselDisplay,
        shortDescription: experience?.shortDescription ?? null,
        description: experience?.description ?? null,
        priceLists: experience?.priceLists ?? null,
        seoInformation: {
          title: (experience?.seoInformation && experience?.seoInformation?.title) ? experience?.seoInformation.title : null,
          metaDescription: (experience?.seoInformation && experience?.seoInformation?.metaDescription) ? experience?.seoInformation.metaDescription : null,
          linkUrl: (experience?.seoInformation && experience?.seoInformation?.linkUrl) ? experience?.seoInformation.linkUrl : null,
          keywords: (experience?.seoInformation && experience?.seoInformation?.keywords) ? experience?.seoInformation.keywords : null,
        },
        linkMenu: {
          text: (experience?.linkMenu && experience?.linkMenu?.text) ? experience?.linkMenu.text : null,
          url: (experience?.linkMenu && experience?.linkMenu?.url) ? experience?.linkMenu.url : null,
          target: "_self",
        },
        cta: {
          text: (experience?.cta && experience?.cta?.text) ? experience?.cta.text : null,
          url: null,
          target: null,
        },
        heading: {
          title: experience?.heading && experience.heading.title ? experience.heading.title : null,
          cta: {
            text: (experience?.heading && experience?.heading?.cta && experience?.heading?.cta?.text) ? experience?.heading?.cta?.text : null,
            url: (experience?.heading && experience?.heading?.cta && experience?.heading?.cta?.url) ? experience?.heading?.cta?.url : null,
            target: (experience?.heading && experience?.heading?.target && experience?.heading?.cta?.target) ? experience?.heading?.cta?.target : null,
          },
          description: experience?.heading && experience.heading.description ? experience.heading.description : null,
          image: experience?.heading && experience.heading.image ? experience.heading.image : null,
        },
        intro: {
          title: experience?.intro && experience.intro.title ? experience.intro.title : null,
          description: experience?.intro && experience.intro.description ? experience.intro.description : null,
          image: null,
          cta: null,
        },
        benefits: [
          {
            title: experience?.benefits && experience.benefits[0]?.title ? experience.benefits[0].title : null,
            description: experience?.benefits && experience.benefits[0]?.description ? experience.benefits[0].description : null,
            image: experience?.benefits && experience.benefits[0]?.image ? experience.benefits[0].image : null,
            cta: {
              text: experience?.benefits && experience.benefits[0]?.cta?.text ? experience.benefits[0].cta.text : null,
              url: experience?.benefits && experience.benefits[0]?.cta?.url ? experience.benefits[0].cta.url : null,
              target: experience?.benefits && experience.benefits[0]?.cta?.target ? experience.benefits[0].cta.target : null,
            },
          },
          {
            title: experience?.benefits && experience.benefits[1]?.title ? experience.benefits[1].title : null,
            description: experience?.benefits && experience.benefits[1]?.description ? experience.benefits[1].description : null,
            image: null,
            cta: null
          },
          {
            title: experience?.benefits && experience.benefits[2]?.title ? experience.benefits[2].title : null,
            description: experience?.benefits && experience.benefits[2]?.description ? experience.benefits[2].description : null,
            image: null,
            cta: null
          },
          {
            title: experience?.benefits && experience.benefits[3]?.title ? experience.benefits[3].title : null,
            description: experience?.benefits && experience.benefits[3]?.description ? experience.benefits[3].description : null,
            image: null,
            cta: null
          },
        ],
        offers: [
          {
            title: experience?.offers && experience.offers[0]?.title ? experience.offers[0].title : null,
            description: experience?.offers && experience.offers[0]?.description ? experience.offers[0].description : null,
            image: null,
            cta: {
              text: experience?.offers && experience.offers[0]?.cta?.text ? experience.offers[0].cta.text : null,
              url: experience?.offers && experience.offers[0]?.cta?.url ? experience.offers[0].cta.url : null,
              target: experience?.offers && experience.offers[0]?.cta?.target ? experience.offers[0].cta.target : null,
            },
          },
          {
            title: experience?.offers && experience.offers[1]?.title ? experience.offers[1].title : null,
            description: experience?.offers && experience.offers[1]?.description ? experience.offers[1].description : null,
            image: experience?.offers && experience.offers[1]?.image ? experience.offers[1].image : null,
            cta: null
          },
          {
            title: experience?.offers && experience.offers[2]?.title ? experience.offers[2].title : null,
            description: experience?.offers && experience.offers[2]?.description ? experience.offers[2].description : null,
            image: experience?.offers && experience.offers[2]?.image ? experience.offers[2].image : null,
            cta: null
          },
          {
            title: experience?.offers && experience.offers[3]?.title ? experience.offers[3].title : null,
            description: experience?.offers && experience.offers[3]?.description ? experience.offers[3].description : null,
            image: experience?.offers && experience.offers[3]?.image ? experience.offers[3].image : null,
            cta: null
          },
        ],
        reviews: experience?.reviews ? experience?.reviews : [
          {
            title: experience?.reviews && experience.reviews[0].title ? experience.reviews[0].title : null,
            description: experience?.reviews && experience.reviews[0].description ? experience.reviews[0].description : null,
            image: null,
            cta: null
          },
        ],
        faq: experience?.faq ? experience?.faq : null,
      });
    }
  }, [experience]);

  if (!experience && Id) {
    return <LoadingApp />;
  }

  return (
    <div className="container-admin mt-5">
      <div className="row">
        <NavLink className="come-back-admin" to={"/admin/experiences"}>
          <FontAwesomeIcon icon={faAngleLeft} />
          {t("Back")}
        </NavLink>
        <div className="row mt-5">

          {/* GENERAL INFORMATIONS */}
          <div className="row mt-2 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("GeneralInformations")}
              </h5>
              <p>{t("ExperiencesGeneralInformations")}</p>
            </div>
            <div className="col-lg-4 col-12">
              <TextField
                id="title"
                name="title"
                label={t("Title")}
                type="text"
                placeholder={t("Insert")}
                value={formValues.title}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    title: e.target.value
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="d-flex flex-column col-lg-3 col-12">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Category")}<span className="text-danger">*</span>
              </label>
              <Select
                options={optionsCategory}
                placeholder={t("Select")}
                className="grey-select"
                onChange={handleSelectChange("category")}
                value={optionsCategory && optionsCategory?.find(
                  (option) => option.value === (formValues.category ?? null)
                )}
                isSearchable={false}
              />
            </div>
            <div className="d-flex flex-column col-lg-2 col-12">
              <TextField
                id="priority"
                name="priority"
                label={t("Priority")}
                type="number"
                placeholder={t("Insert")}
                value={formValues.priority}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    priority: e.target.value
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="d-flex flex-column col-lg-3 col-12">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("Status")}<span className="text-danger">*</span>
              </label>
              <Select
                options={optionsStatus}
                placeholder={t("Select")}
                className="grey-select"
                onChange={handleSelectChange("status")}
                value={optionsStatus.find(
                  (option) => option.value === (formValues.status ?? null)
                )}
                isSearchable={false}
              />
            </div>
            <div className="d-flex col-lg-12 col-12 my-3">
              <label
                className={`ms-1 my-3 fs-6 text-black w-full mb-2 mr-10`}
              >
                {t("CarouselDisplay")}<span className="text-danger">*</span>
              </label>
              <div className="d-flex justify-content-start">
                <label className="flex-wrap my-3 mr-10">
                  <Checkbox
                    onClick={() => {
                      setCarouselDisplay(true);
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        isCarouselDisplay: true
                      }))
                    }}
                    className={"checkbox-admin me-1"}
                    checked={carouselDisplay}
                  />
                  <span className="ms-1">{t("Yes")}</span>
                </label>
                <label className="flex-wrap my-3">
                  <Checkbox
                    onClick={() => {
                      setCarouselDisplay(false);
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        isCarouselDisplay: false
                      }))
                    }}
                    className={"checkbox-admin me-1"}
                    checked={!carouselDisplay}
                  />
                  <span className="ms-1">{t("No")}</span>
                </label>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <TextField
                id="shortDescription"
                name="shortDescription"
                label={t("ShortDescription")}
                type="text"
                placeholder={t("Insert")}
                isRequired={true}
                value={formValues?.shortDescription}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    shortDescription: e.target.value
                  }))
                }
                maxLength={45}
                inputClassName={"grey-input w-100"}
              />
            </div>
          </div>
          <hr />

          {/* DESCRIPTION */}
          <div className="row mt-3 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Description")}
              </h5>
              <p>{t("ExperiencesDescriptionInformations")}</p>

            </div>
            <div className="col-lg-4 col-12">
              <TextField
                id="linkMenuTargetText"
                name="linkMenuTargetText"
                label={t("TextMenu")}
                type="text"
                placeholder={t("Insert")}
                value={formValues.linkMenu?.text}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    linkMenu: {
                      ...prevValues.linkMenu,
                      text: e.target.value
                    }
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="col-lg-4 col-12">
              <TextField
                id="linkMenuUrl"
                name="linkMenuUrl"
                label={t("UrlMenu")}
                type="text"
                placeholder={t("Insert")}
                isRequired={true}
                value={formValues.linkMenu?.url}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    linkMenu: {
                      ...prevValues.linkMenu,
                      url: e.target.value
                    }
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="col-12 mt-3">
              <label className="ms-1 fs-6 text-black mb-3">
                {t("Description")}<span className="text-danger">*</span>
              </label>
              <Editor
                value={formValues?.description}
                onTextChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    description: e.htmlValue
                  }));
                }}
                placeholder={t("Insert")}
                className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
              />
            </div>
            <div className="col-lg-4 col-12 mt-5 mt-lg-2">
              <TextField
                id="ctaText"
                name="ctaText"
                label={t("CtaText")}
                type="text"
                placeholder={t("Insert")}
                isRequired={true}
                value={formValues.cta.text}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    cta: { ...prevValues.cta, text: e.target.value },
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="col-lg-4 col-12 mt-5 mt-lg-2">
              <label 
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("DoYouWantToAddDetails")}
              </label>
              <Select
                options={optionsDetailsOrNot}
                placeholder={t("Select")}
                className="grey-select"
                isSearchable={false}
                onChange={(e) => {
                    setIsAddDetails(e.value)
                    if(formValues.priceLists && formValues.priceLists.length > 0 && e.value === true){
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        priceLists: []
                      }));
                    }
                  }}
                value={formValues.priceLists && formValues.priceLists.length > 0 ? optionsDetailsOrNot.find(
                  (option) => option.value === false) : optionsDetailsOrNot.find(
                    (option) => option.value === isAddDetails)}
              />
            </div>
          </div>
          <hr />
          
          {isAddDetails ? (
          <>
            {/* SEO */}
            <div className="row mt-3 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Seo")}
              </h5>
              <p>{t("ExperiencesSeoInformations")}</p>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <div className="d-flex flex-column position-relative">
                <label
                  className={`ms-1 fs-6 text-black w-full mb-2`}
                >
                  {t("Title")}<span className="text-danger">*</span>
                </label>
                <textarea
                  maxLength={60}
                  value={formValues.seoInformation?.title}
                  className="grey-input w-100 min-h-100px"
                  placeholder={t("Insert")}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      seoInformation: {
                        ...prevValues.seoInformation,
                        title: e.target.value,
                      },
                    }))
                  }
                ></textarea>
                <p className="paragraph position-absolute end-0 top-100 font-description-small">
                  {t("Max60")}
                </p>
              </div>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <div className="d-flex flex-column position-relative">
                <label
                  className={`ms-1 text-lg fw-normal fs-6 text-black w-full mb-2`}
                >
                  {t("MetaDescription")}
                </label>
                <textarea
                  maxLength={160}
                  value={formValues.seoInformation?.metaDescription}
                  className="grey-input w-100 min-h-100px"
                  placeholder={t("Insert")}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      seoInformation: {
                        ...prevValues.seoInformation,
                        metaDescription: e.target.value,
                      },
                    }))
                  }
                ></textarea>
                <p className="paragraph position-absolute end-0 top-100 font-description-small ">
                  {t("Max160")}
                </p>
              </div>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <label className={`ms-1 fs-6 text-black w-full mb-2`}>
                {t("LinkUrl")}<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                value={formValues.seoInformation?.linkUrl}
                className="grey-input w-100"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      linkUrl: e.target.value,
                    },
                  }))
                }
              />
            </div>
            <div className="flex-wrap col-lg-6 col-12 mt-3">
              <TagsInput
                label={t("Keywords")}
                key={formValues.seoInformation?.keywords?.join(",")}
                placeholder={t("KeywordsPlaceholder")}
                selectedTags={selectedTags}
                defaultTags={formValues.seoInformation?.keywords ?? []}
              />
            </div>
            </div>
            <hr />

            {/* HEADING */}
            <div className="row mt-3 mb-5">
              <div className="mb-5">
                <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                  {t("Heading")}
                </h5>
                <p>{t("ExperiencesHeadingInformations")}</p>

              </div>
              <div className="col-lg-6 col-12 mt-3">
                <TextField
                  id="title"
                  label={t("Title")}
                  type="text"
                  placeholder={t("Insert")}
                  value={formValues.heading?.title}
                  isRequired={true}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      heading: { ...prevValues.heading, title: e.target.value },
                    }))
                  }
                  inputClassName={"grey-input w-100"}
                />
              </div>
              <div className="col-lg-6 col-12 mt-3">
                <TextField
                  id="CtaText"
                  label={t("CtaText")}
                  type="text"
                  placeholder={t("Insert")}
                  value={formValues.heading?.cta?.text}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      heading: {
                        ...prevValues.heading,
                        cta: {
                          ...prevValues.heading?.cta,
                          text: e.target.value
                        },
                      }
                    }))
                  }
                  inputClassName={"grey-input w-100"}
                />
              </div>
              <div className="col-12 mt-3">
                  <label className="ms-1 fs-6 text-black mb-3">
                    {t("Description")}<span className="text-danger">*</span>
                  </label>
                  <Editor
                    value={formValues?.heading?.description}
                    onTextChange={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        heading: { ...prevValues.heading, description: e.htmlValue },
                      }))
                    }}
                    placeholder={t("Insert")}
                    className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                  />
                </div>

              <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
                <Uploader
                  onChange={(filePaths) => handleGalleryFiles(filePaths, "heading")}
                  onRemove={(index) => handleRemoveImage(index, "heading")}
                  value={formValues.heading?.image ?? []}
                />
              </div>
              <hr />

              {/* Intro */}
              <div className="row mt-3 mb-5">
                <div className="mb-5">
                  <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                    {t("Intro")}
                  </h5>
                  <p>{t("ExperiencesIntroInformations")}</p>
                </div>

                <div className="col-lg-6 col-12 mt-3">
                  <TextField
                    id="IntroTitle"
                    name="IntroTitle"
                    label={t("Title")}
                    type="text"
                    placeholder={t("Insert")}
                    value={formValues.intro?.title}
                    isRequired={true}
                    onChange={(e) =>
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        intro: { ...prevValues.intro, title: e.target.value },
                      }))
                    }
                    inputClassName={"grey-input w-100"}
                  />
                </div>
                <div className="col-12 mt-3">
                  <label className="ms-1 fs-6 text-black mb-3">
                    {t("IntroDescription")}<span className="text-danger">*</span>
                  </label>
                  <Editor
                    value={formValues?.intro?.description}
                    onTextChange={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        intro: { ...prevValues.intro, description: e.htmlValue },
                      }))
                    }}
                    placeholder={t("Insert")}
                    className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                  />
                </div>

              </div>
            </div>
            <hr />

            {/* BENEFITS */}
            <div className="row mt-3 mb-5 custom-mb-responsive">
              <div className="mb-5">
                <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                  {t("Benefits")}
                </h5>
                <p dangerouslySetInnerHTML={{ __html: t("ExperiencesBenefitsInformations") }}></p>
              </div>

              <TabContext
                className={"d-flex mt-5 pt-5"}
                value={valueTabBenefits}
              >
                <TabList
                  orientation="vertical"
                  onChange={handleChangeBenefits}
                  aria-label=""
                  className="custom-tabs-property col-lg-4 col-12"
                >
                  <Tab
                    value={0}
                    label={t("BenefitsDescription")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={1}
                    label={t("FirstBenefit")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={2}
                    label={t("SecondBenefit")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={3}
                    label={t("ThirdBenefit")}
                    className="text-black text-start"
                  />
                </TabList>
                <div className="col-lg-8 col-12">
                  <TabPanel
                    value={valueTabBenefits}
                    index={0}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[0]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                {
                                  ...prevValues.benefits[0],
                                  title: e.target.value,
                                },
                                ...prevValues.benefits.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.benefits ? formValues.benefits[0]?.description : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                {
                                  ...prevValues.benefits[0],
                                  description: e.htmlValue,
                                },
                                ...prevValues.benefits.slice(1),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}
                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaText")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[0]?.cta?.text : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                {
                                  ...prevValues.benefits[0],
                                  cta: {
                                    ...prevValues.benefits[0].cta,
                                    text: e.target.value
                                  }
                                },
                                ...prevValues.benefits.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaUrl")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[0]?.cta?.url : null}
                          onChange={(value) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                {
                                  ...prevValues.benefits[0],
                                  cta:
                                  {
                                    ...prevValues.benefits[0].cta,
                                    url: value.target.value
                                  },
                                },
                                ...prevValues.benefits.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaTarget")}
                        </label>
                        <Select
                          options={optionsCTATarget}
                          placeholder={t("Select")}
                          className="grey-select w-100"
                          onChange={(value) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                {
                                  ...prevValues.benefits[0],
                                  cta:
                                  {
                                    ...prevValues.benefits[0].cta,
                                    target: value.value
                                  },
                                },
                                ...prevValues.benefits.slice(1),
                              ],
                            }))
                          }
                          isSearchable={false}
                          value={optionsCTATarget.find(
                            (option) => option.value === (formValues.benefits ? formValues.benefits[0]?.cta?.target : null)
                          )}
                        />
                      </div>
                      <div className="d-flex flex-column fw-bold text-uppercase col-12 ps-0 mt-5">
                        <Uploader
                          onChange={(filePaths) => handleGalleryExperiencesFiles(filePaths, "benefits", 0)}
                          onRemove={(fileIndex) => handleRemoveExperiencesImage(fileIndex, "benefits", 0)}
                          value={formValues.benefits ? formValues.benefits[0]?.image : []}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabBenefits}
                    index={1}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[1]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 1),
                                {
                                  ...prevValues.benefits[1],
                                  title: e.target.value,
                                },
                                ...prevValues.benefits.slice(2),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.benefits ? formValues.benefits[1]?.description : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 1),
                                {
                                  ...prevValues.benefits[1],
                                  description: e.htmlValue,
                                },
                                ...prevValues.benefits.slice(2),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabBenefits}
                    index={2}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[2]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 2),
                                {
                                  ...prevValues.benefits[2],
                                  title: e.target.value,
                                },
                                ...prevValues.benefits.slice(3),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.benefits ? formValues.benefits[2]?.description || "" : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 2),
                                {
                                  ...prevValues.benefits[2],
                                  description: e.htmlValue,
                                },
                                ...prevValues.benefits.slice(3),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabBenefits}
                    index={3}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.benefits ? formValues.benefits[3]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 3),
                                {
                                  ...prevValues.benefits[3],
                                  title: e.target.value,
                                },
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.benefits ? formValues.benefits[3]?.description : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              benefits: [
                                ...prevValues.benefits.slice(0, 3),
                                {
                                  ...prevValues.benefits[3],
                                  description: e.htmlValue,
                                }
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </TabContext>
            </div>
            <hr />

            {/* OFFERS */}
            <div className="row mt-3 mb-5 custom-mb-responsive">
              <div className="mb-5">
                <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                  {t("Offers")}
                </h5>
                <p>{t("ExperiencesOffersInformations")}</p>
              </div>

              <TabContext
                className={"d-flex mt-5 pt-5"}
                value={valueTabOffers}
              >
                <TabList
                  orientation="vertical"
                  onChange={handleChangeOffers}
                  aria-label=""
                  className="custom-tabs-property col-lg-4 col-12"
                >
                  <Tab
                    value={0}
                    label={t("OffersDescription")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={1}
                    label={t("FirstOffer")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={2}
                    label={t("SecondOffer")}
                    className="text-black text-start"
                  />
                  <Tab
                    value={3}
                    label={t("ThirdOffer")}
                    className="text-black text-start"
                  />
                </TabList>
                <div className="col-lg-8 col-12">
                  <TabPanel
                    value={valueTabOffers}
                    index={0}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[0]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                {
                                  ...prevValues.offers[0],
                                  title: e.target.value,
                                },
                                ...prevValues.offers.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.offers ? formValues.offers[0]?.description : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                {
                                  ...prevValues.offers[0],
                                  description: e.htmlValue,
                                },
                                ...prevValues.offers.slice(1),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaText")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[0]?.cta?.text : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                {
                                  ...prevValues.offers[0],
                                  cta: {
                                    ...prevValues.offers[0].cta,
                                    text: e.target.value
                                  }
                                },
                                ...prevValues.offers.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaUrl")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[0]?.cta?.url : null}
                          onChange={(value) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                {
                                  ...prevValues.offers[0],
                                  cta:
                                  {
                                    ...prevValues.offers[0].cta,
                                    url: value.target.value
                                  },
                                },
                                ...prevValues.offers.slice(1),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-lg-4 col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("CtaTarget")}
                        </label>
                        <Select
                          options={optionsCTATarget}
                          placeholder={t("Select")}
                          className="grey-select w-100"
                          onChange={(value) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                {
                                  ...prevValues.offers[0],
                                  cta:
                                  {
                                    ...prevValues.offers[0].cta,
                                    target: value.value
                                  },
                                },
                                ...prevValues.offers.slice(1),
                              ],
                            }))
                          }
                          isSearchable={false}
                          value={optionsCTATarget.find(
                            (option) => option.value === (formValues.offers ? formValues.offers[0]?.cta?.target : null)
                          )}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabOffers}
                    index={1}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[1]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 1),
                                {
                                  ...prevValues.offers[1],
                                  title: e.target.value,
                                },
                                ...prevValues.offers.slice(2),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.offers ? formValues.offers[1]?.description || "" : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 1),
                                {
                                  ...prevValues.offers[1],
                                  description: e.htmlValue,
                                },
                                ...prevValues.offers.slice(2),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                      <div className="d-flex flex-column fw-bold text-uppercase col-12 ps-0 mt-5">
                        <Uploader
                          onChange={(filePaths) => handleGalleryExperiencesFiles(filePaths, "offers", 1)}
                          onRemove={(fileIndex) => handleRemoveExperiencesImage(fileIndex, "offers", 1)}
                          value={formValues.offers && formValues.offers[1]?.image ? formValues.offers[1]?.image : []}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabOffers}
                    index={2}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[2]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 2),
                                {
                                  ...prevValues.offers[2],
                                  title: e.target.value,
                                },
                                ...prevValues.offers.slice(3),
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.offers ? formValues.offers[2]?.description || "" : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 2),
                                {
                                  ...prevValues.offers[2],
                                  description: e.htmlValue,
                                },
                                ...prevValues.offers.slice(3),
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}

                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                      <div className="d-flex flex-column fw-bold text-uppercase col-12 ps-0 mt-5">
                        <Uploader
                          onChange={(filePaths) => handleGalleryExperiencesFiles(filePaths, "offers", 2)}
                          onRemove={(fileIndex) => handleRemoveExperiencesImage(fileIndex, "offers", 2)}
                          value={formValues.offers && formValues.offers[2]?.image ? formValues.offers[2]?.image : []}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={valueTabOffers}
                    index={3}
                    className="custom-panels-admin-area pe-2"
                  >
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Title")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("Insert")}
                          value={formValues.offers ? formValues.offers[3]?.title : null}
                          onChange={(e) =>
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 3),
                                {
                                  ...prevValues.offers[3],
                                  title: e.target.value,
                                },
                              ],
                            }))
                          }
                          className="grey-input w-100"
                        />
                      </div>
                      <div className="col-12 mt-3">
                        <label className="ms-1 fs-6 text-black mb-2">
                          {t("Description")}
                        </label>
                        <Editor
                          value={formValues.offers ? formValues.offers[3]?.description || "" : null}
                          onTextChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              offers: [
                                ...prevValues.offers.slice(0, 3),
                                {
                                  ...prevValues.offers[3],
                                  description: e.htmlValue,
                                },
                              ],
                            }));
                          }}
                          placeholder={t("Insert")}
                          className={`w-100 mb-5 ${!isMobileTablet ? "h-150" : ""}`}
                        />
                      </div>
                      <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-3 ps-0 mt-5">
                        <Uploader
                          onChange={(filePaths) => handleGalleryExperiencesFiles(filePaths, "offers", 3)}
                          onRemove={(fileIndex) => handleRemoveExperiencesImage(fileIndex, "offers", 3)}
                          value={formValues.offers && formValues.offers[3]?.image ? formValues.offers[3]?.image : []}
                        />
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </TabContext>
            </div>
            <hr />

            {/* REVIEWS */}
            <div className="row mt-3 mb-5">
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="mb-5">
                  <div className="d-flex justify-content-between">
                    <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                      {t("ReviewsList")}
                    </h5>
                    <div className="d-flex mb-4 justify-content-center">
                      <button
                        className="custom-transparent-btn"
                        onClick={() => {
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            reviews: [...(prevValues.reviews || []), { title: "", description: "" }],
                          }));
                        }}
                      >
                        <Plus /> {t("AddReview")}
                      </button>
                    </div>
                  </div>

                  <p>{t("ReviewsDescription")}</p>
                </div>
              </div>
              <div className="d-flex col-12 flex-column">
                {formValues.reviews?.map((review, index) => {
                  if (index === 0) {
                    return (
                      <>
                        <div key={index} className="d-flex row flex-wrap mb-3  pe-lg-5">
                          <div className="mt-3 col-lg-6 col-12">
                            <label className="fs-6 text-black mb-2">
                              {t("Title")}
                            </label>
                            <input
                              type="text"
                              name={`title`}
                              value={review.title || ""}
                              className="grey-input w-100"
                              onChange={(e) => {
                                const updatedList = [...formValues.reviews];
                                updatedList[index].title = e.target.value;
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  reviews: updatedList,
                                }));
                              }}
                              placeholder={t("Insert")}
                            />
                          </div>
                          <div className="mt-3 col-12">
                            <label className="fs-6 text-black mb-2">
                              {t("Description")}
                            </label>
                            <textarea
                              name={`description`}
                              value={review.description || ""}
                              className="grey-input w-100 description-textarea-min-200"
                              onChange={(e) => {
                                const updatedList = [...formValues.reviews];
                                updatedList[index].description = e.target.value;
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  reviews: updatedList,
                                }));
                              }}
                              placeholder={t("Insert")}
                            />
                          </div>
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <div key={index} className="d-flex row flex-wrap mb-3  pe-lg-5">
                        <div className="mt-3 col-lg-5 col-12">
                          <label className="fs-6 text-black mb-2">
                            {t("Review")} {index} {t("Author")}
                          </label>
                          <input
                            type="text"
                            name={`reviews[${index}].author`}
                            value={review.title || ""}
                            onChange={(e) => {
                              const updatedList = [...formValues.reviews];
                              updatedList[index].title = e.target.value;
                              setFormValues((prevValues) => ({
                                ...prevValues,
                                reviews: updatedList,
                              }));
                            }}
                            className="grey-input w-100"
                            placeholder={t("Insert")}
                          />
                        </div>
                        <div className="mt-3 col-lg-6 col-12">
                          <label className="fs-6 text-black mb-2">
                            {t("Review")} {index} {t("Content")}
                          </label>
                          <textarea
                            name={`reviews[${index}].content`}
                            value={review.description || ""}
                            onChange={(e) => {
                              const updatedList = [...formValues.reviews];
                              updatedList[index].description = e.target.value;
                              setFormValues((prevValues) => ({
                                ...prevValues,
                                reviews: updatedList,
                              }));
                            }}
                            className="grey-input w-100 min-h-100px"
                            placeholder={t("Insert")}
                          />
                        </div>
                        <div className="col-1 d-flex align-items-center">
                          <button
                            className="text-black px-4 border-none bg-transparent mt-5"
                            onClick={() => {
                              const updatedList = [...formValues.reviews];
                              updatedList.splice(index, 1);
                              setFormValues((prevValues) => ({
                                ...prevValues,
                                reviews: updatedList,
                              }));
                            }}
                          >
                            <Trash />
                          </button>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            <hr />

            {/* FAQ List */}
            <div className="row mt-3 mb-5">
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="mb-5">
                  <div className="d-flex justify-content-between">
                    <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                      {t("FaqList")}
                    </h5>
                    <div className="d-flex mb-4">
                      <button
                        className="custom-transparent-btn"
                        onClick={() => {
                          setFormValues(prevValues => ({
                            ...prevValues,
                            faq: [...(prevValues.faq || []), { title: '', description: '' }]
                          }));
                        }}
                      >
                        <Plus />{t("AddFaq")}
                      </button>
                    </div>
                  </div>

                  <p>{t("FaqsDescription")}</p>
                </div>

              </div>
              <div className="d-flex col-12 flex-column">
                {formValues.faq?.map((faq, index) => (
                  <div key={index} className="d-flex row flex-wrap mb-3  pe-lg-5">
                    <div className="mt-3 col-lg-5 col-12">
                      <label className="fs-6 text-black mb-2">
                        {t("FAQ")} {index + 1} {t("Title")}
                      </label>
                      <input
                        type="text"
                        name={`faq[${index}].title`}
                        value={faq.title || ''}
                        onChange={e => {
                          const updatedList = [...formValues.faq];
                          updatedList[index].title = e.target.value;
                          setFormValues(prevValues => ({
                            ...prevValues,
                            faq: updatedList,
                          }));
                        }}
                        className="grey-input w-100"
                        placeholder={t("Insert")}
                      />
                    </div>
                    <div className="mt-3 col-lg-6 col-12">
                      <label className="fs-6 text-black mb-2">
                        {t("FAQ")} {index + 1} {t("Answer")}
                      </label>
                      <textarea
                        name={`faq[${index}].description`}
                        value={faq.description || ''}
                        onChange={e => {
                          const updatedList = [...formValues.faq];
                          updatedList[index].description = e.target.value;
                          setFormValues(prevValues => ({
                            ...prevValues,
                            faq: updatedList,
                          }));
                        }}
                        className="grey-input w-100 min-h-100px"
                        placeholder={t("Insert")}
                      />
                    </div>
                    {/* Delete Button */}
                    <div className="col-lg-1 col-12 d-flex align-items-center">
                      <button
                        className="text-black px-4 border-none bg-transparent mt-5"
                        onClick={() => {
                          const updatedList = [...formValues.faq];
                          updatedList.splice(index, 1);
                          setFormValues(prevValues => ({
                            ...prevValues,
                            faq: updatedList,
                          }));
                        }}
                      >
                        <Trash />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
          ) : (
            <>
            <div>
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("ExperienceBackgroundPhoto")}
              </h5>
              <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
                <Uploader
                  onChange={(filePaths) => handleGalleryFiles(filePaths, "heading")}
                  onRemove={(index) => handleRemoveImage(index, "heading")}
                  value={formValues.heading?.image ?? []}
                />
              </div>
            </div>
            <div className="mb-5 d-flex justify-content-between align-items-center">
              <div>
                  <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                    {t("PriceLists")}
                  </h5>
                  <p>{t("PriceListsInformation")}</p>
              </div>
              <div className="mb-4">
                <button
                  className="custom-transparent-btn d-flex align-items-center justify-content-center"
                  onClick={addPriceList}
                >
                  <Plus />
                  {t("AddPriceList")}
                </button>
              </div>
            </div>
              {formValues.priceLists && formValues.priceLists.map((priceListData, index) => (
              <div className="mb-3">
                <div 
                  className="w-100 d-flex justify-content-between align-items-center mb-3"
                >
                  <span
                    className="text-black fs-6 mb-6 fw-semibold text-uppercase"
                  >
                    {priceListData.title || `${t("PriceList")} ${index + 1}`}
                  </span>
                  <button
                    type="button" 
                    onClick={(event) => {
                      event.stopPropagation(); 
                      removePriceList(index);
                    }}
                    className="text-black px-4 border-none bg-transparent lh-1 cursor-pointer"
                    aria-label={t("RemovePriceList") + ` ${index + 1}`}
                    title={t("RemovePriceList")}
                  >
                    <Trash />
                  </button>
                </div>
                <div className="row justify-content-between align-items-center flex-wrap">
                  <div className="col-lg-6 col-12 mt-3">
                      <TextField
                        id={`title-${index}`}
                        name={`title-${index}`}
                        label={t("Title")}
                        type="text"
                        placeholder={t("Insert")}
                        value={priceListData.title ?? ""}
                        isRequired={true}
                        onChange={(e) =>
                          setFormValues((prevValues) => {
                              const updatedPriceLists = [...prevValues.priceLists];
                              updatedPriceLists[index] = {
                                ...updatedPriceLists[index],
                                title: e.target.value,
                              };
                              return { ...prevValues, priceLists: updatedPriceLists };
                          })
                        }
                        inputClassName={"grey-input w-100"}
                      />
                  </div>
                  <div className="col-12 mt-3">
                      <label 
                        className={`ms-1 fs-6 text-black w-full mb-2`}
                      >
                        {t("Description")}
                      </label>
                      <Editor
                        value={priceListData.description ?? ''}
                        onTextChange={(e) =>
                          setFormValues((prevValues) => {
                            const updatedPriceLists = [...prevValues.priceLists];
                            updatedPriceLists[index] = {
                              ...updatedPriceLists[index],
                              description: e.htmlValue,
                            };
                            return { ...prevValues, priceLists: updatedPriceLists };
                          })
                        }
                        placeholder={t("Insert")}
                        className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      />
                  </div>
                  <div className="col-12 mt-3">
                      <label 
                        className={`ms-1 fs-6 text-black w-full mb-2`}
                      >
                        {t("LeftInformation")}
                      </label>
                      <Editor
                        value={priceListData.leftInformation ?? ''}
                        onTextChange={(e) =>
                          setFormValues((prevValues) => {
                            const updatedPriceLists = [...prevValues.priceLists];
                            updatedPriceLists[index] = {
                              ...updatedPriceLists[index],
                              leftInformation: e.htmlValue,
                            };
                            return { ...prevValues, priceLists: updatedPriceLists };
                          })
                        }
                        placeholder={t("Insert")}
                        className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      />
                  </div>
                  <div className="col-12 mt-3">
                      <label 
                        className={`ms-1 fs-6 text-black w-full mb-2`}
                      >
                        {t("RightInformation")}
                      </label>
                      <Editor
                        value={priceListData.rightInformation ?? ''}
                        onTextChange={(e) =>
                          setFormValues((prevValues) => {
                            const updatedPriceLists = [...prevValues.priceLists];
                            updatedPriceLists[index] = {
                              ...updatedPriceLists[index],
                              rightInformation: e.htmlValue,
                            };
                            return { ...prevValues, priceLists: updatedPriceLists };
                          })
                        }
                        placeholder={t("Insert")}
                        className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      />
                  </div>
                </div> 
                {((formValues.priceLists.length > 0 || (index === 0 && formValues.priceLists.length > 1)) && index !== formValues.priceLists.length - 1) && (
                  <hr />   
                )}
              </div>
              ))}
            </>
          )}
        </div>
      </div>
      <div className="col-12 mt-3 d-flex justify-content-end p-5 p-lg-0">
        <button onClick={handleSubmit} className="admin-button border-none text-uppercase" disabled={isBtnDisable}>
          {Id ? t("Update") : t("Create")}
        </button>
      </div>
    </div>
  );
};

export default Manage;